<template>
  <div ref="root" class="admin-user-menu">
    <button class="admin-user-menu__trigger" type="button" @click="toggleMenu">
      <span class="admin-user-menu__name">{{ displayName }}</span>
      <span class="admin-user-menu__arrow" :class="{ 'is-open': open }"></span>
    </button>

    <transition name="admin-user-menu-fade">
      <div v-if="open" class="admin-user-menu__dropdown">
        <button class="admin-user-menu__action" type="button" @click="handleLogout">
          退出登录
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'AdminUserMenu',
  props: {
    displayName: {
      type: String,
      default: '未登录用户',
    },
  },
  data() {
    return {
      open: false,
    }
  },
  mounted() {
    document.addEventListener('click', this.handleDocumentClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick)
  },
  methods: {
    toggleMenu() {
      this.open = !this.open
    },
    handleLogout() {
      this.open = false
      this.$emit('logout')
    },
    handleDocumentClick(event) {
      if (!this.$refs.root || this.$refs.root.contains(event.target)) return
      this.open = false
    },
  },
}
</script>

<style scoped>
.admin-user-menu {
  position: relative;
}

.admin-user-menu__trigger {
  min-width: 150px;
  height: 42px;
  padding: 0 14px 0 18px;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  border: 1px solid #d9e0ee;
  border-radius: 999px;
  background: #fff;
  color: #0f172a;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.admin-user-menu__trigger:hover {
  border-color: #b9c6e4;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
}

.admin-user-menu__name {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.admin-user-menu__arrow {
  width: 9px;
  height: 9px;
  border-right: 1.8px solid currentColor;
  border-bottom: 1.8px solid currentColor;
  transform: rotate(45deg) translateY(-2px);
  transition: transform 0.2s ease;
}

.admin-user-menu__arrow.is-open {
  transform: rotate(-135deg) translateY(-1px);
}

.admin-user-menu__dropdown {
  position: absolute;
  top: calc(100% + 10px);
  right: 0;
  min-width: 160px;
  padding: 8px;
  border: 1px solid #e4e8f2;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
}

.admin-user-menu__action {
  width: 100%;
  min-height: 42px;
  border: 0;
  border-radius: 12px;
  background: #fff;
  color: #d93c3c;
  font-size: 14px;
  cursor: pointer;
}

.admin-user-menu__action:hover {
  background: #fef2f2;
}

.admin-user-menu-fade-enter-active,
.admin-user-menu-fade-leave-active {
  transition: opacity 0.16s ease, transform 0.16s ease;
}

.admin-user-menu-fade-enter,
.admin-user-menu-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
